<template>
    <q-list no-border link class="v-menu q-pa-none" v-if="user && items.length">
        <div class="p-btn-menu row" v-if="!isMobile">
            <v-button flat dense round @click.native="$emit('leftDrawerToogleDesktop')" color="primary" icon="fa icon-light-menu"
                tour="briefing-2" :tour-title="$T('menu')"
                :tour-content="$T('click here to access menu items')"
                v-if="$route.name !== 'home'"></v-button>
            <img v-if="!isMobile" src="../../img/iqos/iqos_logo.svg" class="tb-btn-height self-center" :alt="appName"/>
        </div>
        <q-list-header class="column q-pa-sm justify-center" v-if="isMobile">
            <div class="row justify-end col-12">
                <v-button class="icon-sm col-1" flat dense round icon="fa icon-close" size="sm" color="primary" @click.native="$emit('closeMenu')"></v-button>
            </div>
            <div class="row justify-center col-12">
                <lending-point-dropdown v-if="user && user.role && (user.role.name == 'Sales Expert' || user.role.name == 'MUPI' || user.role.name == 'Remote Coach')" tour="briefing-6"
                                        :useLabel = false
                                        :tour-title="$T('lending points')"
                                        :tour-content="$T('click here to switch between lending points')" class="col-11 text-weight-bold" :style="$q.screen.gt.sm ? 'width:31vw;' : ''">
                </lending-point-dropdown>
            </div>
            <!-- <img src="../../img/iqos/iqos_logo.svg" width="70%"/> -->
        </q-list-header>
        <!--<hr class="q-mt-none q-mb-md lt-md" style="border: 0,5px solid #A9A7AD" />-->
        <div class="column">
            <template v-for="rootItem in items">
                <q-item class="q-pa-md" item exact :to="{ name: rootItem.route }" @click.native="changeStateOfMenu(stateMenu)">
                    <q-item-side class="icon-lg" :icon="rootItem.icon"/>
                    <q-item-main class="font-regular-18" :label="$T(rootItem.label)"/>
                    <q-item-side right>
                        <q-item-tile class="icon-md lt-md" icon="fa icon-chevron-right" color="primary"></q-item-tile>
                    </q-item-side>
                </q-item>
            </template>
            <div class="row justify-around q-px-md q-mt-lg items-center" v-if="isMobile">
                <q-item class="q-px-none text-subtitle1" @click.native="logout" v-close-overlay>
                    {{ $T('log out') }}
                </q-item>
                <locale-dropdown
                    tour="briefing-7"
                    :tour-title="$T('language')"
                    :tour-content="$T('click here to change the language')">
                </locale-dropdown>
            </div>
        </div>
    </q-list>
</template>

<script>
    import {mapGetters} from 'vuex'
    import axios from 'axios'

    import LocaleDropdown from './LocaleDropdown'
    import LendingPointDropdown from './DropdownLendingPoint'

    import {
        uid,
        QList,
        QListHeader,
        QCollapsible,
        QItem,
        QItemSide,
        QItemMain
    } from 'quasar-framework'

    export default {
        components: {
            QList,
            QListHeader,
            QCollapsible,
            QItem,
            QItemSide,
            QItemMain,
            LocaleDropdown,
            LendingPointDropdown
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
            })
        },

        data() {
            return {
                groupId: uid(),
                mockData: null,
                isMenuOpen: this.menuOpened,
                isMobile: this.$q.platform.is.mobile || this.$q.platform.is.ipad || this.$q.platform.is.platform === 'ipad' || this.$q.platform.has.touch,
                appName: window.config.appName
            }
        },

        props:{
            items: {
                type: Array,
                default(){
                    return []
                }
            },
            stateMenu: {
                type: Object
            }
        },

        methods: {
            async getMockData() {
                const {data} = await axios.get(`${config.appUrl}/api/v1/home/kpis`)
                this.mockData = data.data
            },
            async logout() {
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                //this.$router.push({name: 'login'})
                window.location.href = '/login'
            },
            changeStateOfMenu(stateObj){
                this.$emit('changeMenu', stateObj)
            }
        },
        mounted() {
            this.isMobile = this.$q.platform.is.mobile || this.$q.platform.is.ipad || this.$q.platform.is.platform === 'ipad' || this.$q.platform.has.touch
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue